import { useNavigate } from 'react-router-dom';
import { openInNewTab } from 'src/utils/helper';
import Banner from './banner/banner';
import ServiceCards from './cards/service-cards';
import css from './list.module.scss';
import { BlockListProps, Service } from 'src/types';
import { fireEvent } from 'src/utils/analytics/google';

export default function List({
  servicesBlocks,
  servicesLimit,
  showCardsPagination,
  className,
  tag,
  pages
}: Readonly<BlockListProps>) {
  const navigate = useNavigate();

  if (servicesBlocks.length === 0) {
    return null;
  }

  const generateKey = (name: string) => {
    return `${name}_${new Date().getTime()}`;
  };

  function onServiceClick(service: Partial<Service>) {
    const baseUrl = window.location.origin;
    const pathname = window.location.pathname;
    const url = service.url;
    const pagesUrl = '/pages';
    fireEvent('view_service', { title: service.title, url });

    if (service.phone) {
      openInNewTab(`tel:${service.phone}`);
      return;
    }

    if (!(url?.startsWith(baseUrl) || url?.startsWith('/'))) {
      openInNewTab(url);
      return;
    }

    if (url?.includes(pagesUrl)) {
      navigate(url, {
        state: { tag: tag, slug: service.slug, pages: pages ? [pages] : [] }
      });
      return;
    }

    navigate(url.startsWith(baseUrl) ? url.replace(baseUrl, '') : pathname + url, {
      state: { tag: tag, slug: service.slug }
    });
  }

  const renderCards = () => {
    let bannerGroup: JSX.Element[] = [];
    const result: JSX.Element[] = [];
    servicesBlocks.forEach((servicesBlock) => {
      if (servicesBlock.blockType === 0) {
        bannerGroup.push(
          <Banner key={servicesBlock.id} service={servicesBlock.services[0]} pages={pages} className={className} />
        );
      } else {
        result.push(
          <div key={generateKey(servicesBlock.blockTitle)} className={css.bannerGroup}>
            {bannerGroup}
          </div>
        );
        result.push(
          <ServiceCards
            key={servicesBlock.id}
            blockTitle={servicesBlock.blockTitle}
            services={servicesBlock.services}
            className={className}
            servicesLimit={servicesLimit}
            showCardsPagination={showCardsPagination}
            onClick={onServiceClick}
          />
        );
        bannerGroup = [];
      }
    });
    result.push(
      <div key={generateKey('block')} className={css.bannerGroup}>
        {bannerGroup}
      </div>
    );
    return result;
  };

  return <div className={css.servicesContainer}>{renderCards()}</div>;
}
